import { de } from './catalogues/de.js';
import { en } from './catalogues/en.js';
import { es } from './catalogues/es.js';
import { fr } from './catalogues/fr.js';
import { it } from './catalogues/it.js';
import { nl } from './catalogues/nl.js';
export * from './locales.js';
export * from './plural.js';
/**
 * Un catalogue par langue gérée.
 *
 * `Record<Locale, Messages>` plutôt qu'un `switch` : si une langue est ajoutée à `LOCALES`
 * sans que son catalogue existe ici, le compilateur le signale — la liste des langues et
 * celle des traductions ne peuvent pas diverger silencieusement.
 */
export const CATALOGUES = { fr, en, de, es, it, nl };
/** Le catalogue d'une langue. Toujours défini : `Locale` ne contient que des clés couvertes. */
export function messagesPour(locale) {
    return CATALOGUES[locale];
}
//# sourceMappingURL=index.js.map